module.exports = __webpack_public_path__ + "media/games-6.63c7fe7b.mp4";